import React from "react"

import Layout from "src/components/layout"
import Head from "../../components/Head"
import {graphql, useStaticQuery} from "gatsby"
import {useTranslation} from "react-i18next";
import BRANDS from "../../brands";

const NotFoundPage = ({location}) => {
  const data = useStaticQuery(graphql`
    query errorPageClientsRu {
      site {
        siteMetadata {
          countries {
            ru {
              hotLine {
                tel
                title
                whatsapp
              }
            }
          }
        }
      }
    }
  `)

  const {t} = useTranslation()

  return (
    <>
      <Head
        lang="ru"
        title={t('head.404.title', { brand: BRANDS.ALLSPORTS.brand } )}
        slug="/404/"
      />
      <Layout
        hotLine={data.site.siteMetadata.countries.ru.hotLine}
        location={location}
        country="ru"
      >
        <h1>NOT FOUND</h1>
        <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
      </Layout>
    </>
  )
}

export default NotFoundPage
